import config from './config'
import login from './login'
import notification from './notification'

export default {
  config,
  login,
  notification,
}
